module.exports = __webpack_public_path__ + "img/game／pic.286c4e00.png";